import React from 'react';
import { MessageCircle, ArrowRight, Star } from 'lucide-react';
import { waLink } from '../mock';

export default function Hero() {
  return (
    <section id="home" className="relative min-h-screen flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center scale-105"
        style={{ backgroundImage: "url('https://images.unsplash.com/photo-1502602898657-3e91760cbb34?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920')" }}
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#071a33]/90 via-[#0B2545]/75 to-[#0B2545]/40" />

      <div className="relative max-w-7xl mx-auto px-5 md:px-8 w-full pt-28 pb-16">
        <div className="max-w-2xl">
          <p className="section-eyebrow text-[#ffb08a] mb-4 reveal">
            <span className="h-px w-8 bg-[#EA5019] inline-block" /> DISCOVER EXTRAORDINARY JOURNEYS
          </p>
          <h1 className="font-heading text-4xl sm:text-5xl md:text-6xl font-extrabold text-white leading-[1.08] reveal">
            Where Will Your Next <span className="text-[#ff7a45]">Journey</span> Take You?
          </h1>
          <p className="mt-6 text-base md:text-lg text-white/80 leading-relaxed reveal">
            From serene beaches and majestic mountains to vibrant cities and timeless cultures, discover handcrafted journeys designed around the way you love to travel.
          </p>

          <div className="mt-9 flex flex-col sm:flex-row gap-4 reveal">
            <a
              href={waLink}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-[#EA5019] text-white font-semibold hover:bg-[#cf4413] transition-all shadow-[0_12px_30px_rgba(234,80,25,0.4)] hover:-translate-y-1 duration-200"
            >
              <MessageCircle size={20} /> WhatsApp for Free Quote
            </a>
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 px-7 py-4 rounded-full bg-white/10 border border-white/40 text-white font-semibold hover:bg-white hover:text-[#0B2545] transition-all backdrop-blur-sm"
            >
              Get in Touch <ArrowRight size={18} />
            </a>
          </div>

          <div className="mt-12 flex flex-wrap items-center gap-8 reveal">
            <div>
              <div className="flex items-center gap-1 text-[#ffb703]">
                {[...Array(5)].map((_, i) => <Star key={i} size={18} fill="#ffb703" strokeWidth={0} />)}
              </div>
              <p className="text-white/70 text-sm mt-1">4.9/5 from happy travellers</p>
            </div>
            <div className="h-10 w-px bg-white/20" />
            <div>
              <p className="font-heading text-2xl font-extrabold text-white">12+</p>
              <p className="text-white/70 text-sm">Global regions covered</p>
            </div>
            <div className="h-10 w-px bg-white/20" />
            <div>
              <p className="font-heading text-2xl font-extrabold text-white">10K+</p>
              <p className="text-white/70 text-sm">Journeys crafted</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden md:flex flex-col items-center gap-2 text-white/60">
        <span className="text-xs tracking-widest">SCROLL</span>
        <span className="h-10 w-px bg-white/40 animate-pulse" />
      </div>
    </section>
  );
}
